import Axios, { AxiosRequestConfig, AxiosError } from 'axios';
 
import { store } from '../../store'

export const AXIOS_INSTANCE = Axios.create({ baseURL: process.env.REACT_APP_CORE_API_URL });

AXIOS_INSTANCE.interceptors.request.use(
  config => {
    const {
      auth: { accessToken, isAuthenticated }
    } = store.getState()
    if (isAuthenticated) {
      // @ts-ignore
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

AXIOS_INSTANCE.interceptors.response.use(
  // res func was messing res up, data would always be undefined
  res => res,
  async err => {
    // anything above 2xx status
    const {
      // @ts-ignore
      auth: { isAuthenticated, isSSOUser, isRefreshingSSO }
    } = store.getState()

    const {
      auth: { refreshAccessToken, resumeSession, setIsRefreshingSSO }
    } = store.getActions()
    const { config, response } = err
    const contentType = response.headers['content-type']

    if (response.status === 401 && isAuthenticated && !isRefreshingSSO) {
      if (!config._retry) {
        config._retry = true
        try {
          if (isSSOUser) {
            setIsRefreshingSSO(true)
            await refreshAccessToken()
            setIsRefreshingSSO(false)
          } else {
            await resumeSession() // attempt to refresh cognito token
          }
          return AXIOS_INSTANCE(config) // retry the call
        } catch (_error) {
          // await logout()
          console.log('should log out')
          return Promise.reject(_error)
        }
      } else {
        console.log('should log out')
        // await logout()
      }
    } else if (contentType && contentType.indexOf('application/json') !== -1) {
      const jsonError = err.response.data
      return Promise.reject(jsonError)
    } else {
      return Promise.reject(err.response.status)
    }
  }
)

// add a second `options` argument here if you want to pass extra options to each generated query
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    headers: {
      ...options?.headers,
    }
  }).then(({ data }) => data);

  return promise;
};

export type ErrorType<Error> = AxiosError<Error>;
